export default __webpack_public_path__ + "static/media/rejected.803c1cca.svg";